// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1GcgG","content":"styles_content__1x8z6"};